import i18next from 'i18next';

export const validate = values => {
  const errors = {};

  //   assets
  if (values.assets.length === 0) {
    errors.assets = i18next.t('validate_asset');
  }

  //   organizations
  if (values.organizations.length === 0) {
    errors.organizations = i18next.t('validate_organizations');
  }

  // accommodations
  if (values.accommodations.length === 0) {
    errors.accommodations = i18next.t('accommodations_validate');
  }

  // description
  if (!values.description) {
    errors.description = i18next.t('description_validate');
  } else if (values.description && values.description.length < 2) {
    errors.description = i18next.t('description_length_validate');
  }

  //   image
  // if (values.image.id === 0) {
  //   errors.image = i18next.t('choose_photo_for_entertainment');
  // }

  // Cover
  if (values.uploadImage === null) {
    errors.uploadImage = i18next.t('game_cover_validate');
  }

  return errors;
};
